import { type IProviderService } from './provider/IProviderService'
import { type TEventName } from './TEventName'

export interface Channel {
  readonly name: string
  on<T>(event: TEventName, handler: (data: T) => void): void
  off<T>(event: TEventName, handler: (data: T) => void): void
  unsubscribe(): void
}

export class ProviderChannel implements Channel {
  constructor(
    public readonly name: string,
    private readonly service: IProviderService,
    private readonly onUnsubscribe: (name: string) => void,
  ) {}

  on<T>(event: TEventName, handler: (data: T) => void): void {
    this.service.onEvent<T>(this.name, event, handler)
  }

  off<T>(event: TEventName, handler: (data: T) => void): void {
    this.service.offEvent<T>(this.name, event, handler)
  }

  unsubscribe(): void {
    this.service.unsubscribe(this.name)
    this.onUnsubscribe(this.name)
  }
}
